<template>
  <v-container fluid fill-height>
    <div id="mapDiv"></div>
  </v-container>
</template>

<style scoped>
#mapDiv {
  width: 90vw;
  height: 75vh;
}
</style>

<script>

import 'leaflet/dist/leaflet.css';
import L from 'leaflet';
import gql from 'graphql-tag';

const UPDATE_USER_MAPLAYER = gql`
mutation update_user_maplayer($sub: String!, $map_layer: String!) {
  update_users_by_pk(
    pk_columns: { sub: $sub },
    _set: {
      map_layer: $map_layer
    }
  ) {
    map_layer
  }
}
`;

export default {
  name: 'DeviceLocation',
  data() {
    return {
      map: null,
      marker: null,
      ignoreLayerSelectionOnce: true,
    };
  },
  props: {
    device: {
      type: Object,
      required: true,
    },
  },
  methods: {
    setLocation(e) {
      const coord = e.latlng;
      const newLatLng = new L.LatLng(coord.lat, coord.lng);
      this.marker.setLatLng(newLatLng);

      const location = {
        type: 'Point',
        coordinates: [coord.lat, coord.lng],
      };

      this.device.location = location;
    },
    layerSelected(e) {
      if (this.ignoreLayerSelectionOnce) {
        this.ignoreLayerSelectionOnce = false;
        return;
      }
      this.$store.commit('mapLayer', e.name);
      this.saveMapLayer();
    },
    saveMapLayer() {
      // eslint-disable-next-line
      const sub = this.$store.state.user.attributes.sub;
      // eslint-disable-next-line
      const map_layer = this.$store.state.mapLayer;

      const variables = {
        sub,
        map_layer,
      };

      this.$apollo.mutate({
        mutation: UPDATE_USER_MAPLAYER,
        variables,
        // eslint-disable-next-line
        update: (cache, { data: { update_users } }) => {
          // TODO error handling what if mutation doesn't work
        },
      });
    },
  },
  mounted() {
    let lat = 0;
    let lng = 0;
    let hasSavedLocation = false;
    if (this.device && this.device.location && this.device.location.coordinates) {
      hasSavedLocation = true;
      // eslint-disable-next-line
      lat = this.device.location.coordinates[0];
      // eslint-disable-next-line
      lng = this.device.location.coordinates[1];
    }

    // this.map = L.map('locationsMap', {
    //   minZoom: 4,
    //   maxZoom: 18,
    //   attributionControl: false,
    //   center: [lat, lng],
    //   zoom: 13,
    // });
    // // Create tile layer
    // const wmtsLayer = L.tileLayer('https://avoin-karttakuva.maanmittauslaitos.fi/avoin/wmts/1.0.0/maastokartta/default/WGS84_Pseudo-Mercator/{z}/{y}/{x}.png', { id: 'Maastokartta' });
    // wmtsLayer.addTo(this.map);

    // eslint-disable-next-line
    const mapBoxSatellite = L.tileLayer('https://api.mapbox.com/styles/v1/mapbox/satellite-v9/tiles/{z}/{x}/{y}?access_token=pk.eyJ1IjoiaGVpa2tpcyIsImEiOiJjanp3YnBvaGwwZDR0M2hwZ29zdXZmeDh4In0.cxRko2MWKrQ520oi1G0_9A', {
      tileSize: 512,
      zoomOffset: -1,
      attribution: '© <a href="https://apps.mapbox.com/feedback/">Mapbox</a> © <a href="http://www.openstreetmap.org/copyright">OpenStreetMap</a>',
    });
    // eslint-disable-next-line
    const mapBoxStreets = L.tileLayer('https://api.mapbox.com/styles/v1/mapbox/streets-v11/tiles/{z}/{x}/{y}?access_token=pk.eyJ1IjoiaGVpa2tpcyIsImEiOiJjanp3YnBvaGwwZDR0M2hwZ29zdXZmeDh4In0.cxRko2MWKrQ520oi1G0_9A', {
      tileSize: 512,
      zoomOffset: -1,
      attribution: '© <a href="https://apps.mapbox.com/feedback/">Mapbox</a> © <a href="http://www.openstreetmap.org/copyright">OpenStreetMap</a>',
    });
    const openStreetMap = L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
      attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors',
    });
    const maanmittauslaitos = L.tileLayer('https://avoin-karttakuva.maanmittauslaitos.fi/avoin/wmts/1.0.0/maastokartta/default/WGS84_Pseudo-Mercator/{z}/{y}/{x}.png', { id: 'Maastokartta' });

    let defaultLayerName = this.$store.state.mapLayer;
    if (defaultLayerName === undefined || defaultLayerName === null) {
      defaultLayerName = 'Maanmittauslaitos';
    }

    const mapLayers = {
      // eslint-disable-next-line
      'MapBoxSatellite': mapBoxSatellite,
      // eslint-disable-next-line
      'MapBoxStreets': mapBoxStreets,
      // eslint-disable-next-line
      'OpenStreetMap': openStreetMap,
      // eslint-disable-next-line
      'Maanmittauslaitos': maanmittauslaitos,
    };

    this.map = L.map('mapDiv', {
      minZoom: 4,
      maxZoom: 18,
      zoomControl: false,
      layers: [mapLayers[defaultLayerName]],
    });
    this.map.on('baselayerchange ', this.layerSelected);

    L.control.layers(mapLayers, null, { position: 'topleft' }).addTo(this.map);

    this.map.setView(new L.LatLng(lat, lng), 12);

    if (hasSavedLocation) {
      this.marker = L.circleMarker([lat, lng], {
        radius: 10, fillOpacity: 1, color: '#ff0000', uid: '1',
      }).addTo(this.map);
    }

    this.map.on('click', this.setLocation);
  },
};
</script>
